import React, { useEffect, useState } from "react";
import axios from "axios";
import "./ImageAdsPage.css";

const ImageAdsPage = () => {
  const [ad, setAd] = useState(null);

  const BASE_URL =
    window.location.hostname === "localhost"
      ? "http://localhost:5000"
      : "https://success-blog-app-backend.onrender.com";

  const addView = async (id) => {
    try {
      // 🚀 No restriction, every view counts
      await axios.post(`${BASE_URL}/api/ads/view/${id}`);
    } catch (err) {
      console.log("View update failed", err);
    }
  };

  useEffect(() => {
    const fetchAds = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/ads/all-ads`);

        const ads = res.data.filter(
          (a) => a.adType === "image" && a.views < a.maxViews
        );

        if (!ads.length) return;

        let index = parseInt(localStorage.getItem("imgIndex")) || 0;

        if (index >= ads.length) index = 0;

        const selected = ads[index];

        localStorage.setItem("imgIndex", index + 1);

        setAd(selected);

        // 👇 every load counts as view (no limit)
        addView(selected._id);
      } catch (err) {
        console.log("Error loading ads", err);
      }
    };

    fetchAds();
  }, []);

  if (!ad) return null;

  return (
    <div className="image-ad-wrapper">
      <div
        className="image-ad-box"
        onClick={() => ad.link && window.open(ad.link, "_blank")}
      >
        <img src={ad.image} alt="ad" className="image-ad-img" />
      </div>
    </div>
  );
};

export default ImageAdsPage;